import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

const SalesUnavailable = () => {
  useEffect(() => {
    document.title = "Satış İşlemleri Geçici Olarak Kapalı | Global Yol Yardım";
  }, []);

  return (
    <div className="page-content">
      <Container fluid>
        <Row className="justify-content-center">
          <Col xl={7} lg={9}>
            <Card>
              <CardBody className="p-4 p-md-5 text-center">
                <div className="avatar-lg mx-auto mb-4">
                  <div className="avatar-title bg-warning-subtle text-warning rounded-circle fs-1">
                    <i className="ri-shopping-cart-2-line" />
                  </div>
                </div>

                <h3 className="mb-3">Satış işlemleri geçici olarak kapalı</h3>
                <p className="text-muted mb-4 fs-15">
                  Paket satışı, toplu satış ve sözleşme yenileme işlemleri kısa
                  bir süreliğine kullanılamamaktadır.
                </p>

                <Link to="/dashboard" className="btn btn-primary">
                  <i className="ri-arrow-left-line align-bottom me-1" />
                  Ana Sayfaya Dön
                </Link>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SalesUnavailable;
